module.exports = __webpack_public_path__ + "static/media/accompany_important.08e0d5ef.svg";